import React from 'react';
import { FormControlLabel, Grid, Switch, TextField, Typography } from '@mui/material';
import { PaymentMethod } from 'types/paymentMethod';

// os campos de texto e de número entregam string; o switch entrega 0 ou 1
export type PaymentMethodChange = (index: keyof PaymentMethod, value: string | number) => void;

export type PaymentMethodErrors = Partial<Record<'name' | 'type' | 'max_installments', string>>;

export function validatePaymentMethod(paymentMethod: PaymentMethod): PaymentMethodErrors {
  const errors: PaymentMethodErrors = {};

  if (!paymentMethod.name) errors.name = 'Nome é obrigatório';
  if (!paymentMethod.type) errors.type = 'Tipo é obrigatório';
  if (!paymentMethod.max_installments || Number(paymentMethod.max_installments) <= 0) {
    errors.max_installments = 'Informe um número maior que zero';
  }

  return errors;
}

interface PaymentMethodFormProps {
  paymentMethod: PaymentMethod;
  handleChange: PaymentMethodChange;
  errors: PaymentMethodErrors;
}

const PaymentMethodForm: React.FC<PaymentMethodFormProps> = ({ paymentMethod, handleChange, errors }) => {
  return (
    <Grid container size={12} spacing={2} maxWidth={900}>
      <Grid size={12}>
        <Typography variant="subtitle2" fontWeight={700} color="primary">
          Dados da forma de recebimento
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          fullWidth
          autoFocus
          label="Nome"
          placeholder="Digite o nome da forma de recebimento"
          value={paymentMethod.name}
          onChange={e => handleChange('name', e.target.value)}
          error={!!errors.name}
          helperText={errors.name}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          label="Tipo"
          placeholder="Ex.: P"
          value={paymentMethod.type}
          onChange={e => handleChange('type', e.target.value)}
          error={!!errors.type}
          helperText={errors.type || 'Código curto, único por forma'}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 3 }}>
        <TextField
          fullWidth
          type="number"
          label="Máximo de parcelas"
          value={paymentMethod.max_installments}
          onChange={e => handleChange('max_installments', e.target.value)}
          error={!!errors.max_installments}
          helperText={errors.max_installments}
          slotProps={{ htmlInput: { min: 1 } }}
        />
      </Grid>

      <Grid size={12}>
        <FormControlLabel
          label="Ativo"
          control={
            <Switch checked={!!paymentMethod.active} onChange={e => handleChange('active', e.target.checked ? 1 : 0)} />
          }
        />
      </Grid>
    </Grid>
  );
};

export default PaymentMethodForm;
